<section class="page-banner-sec" [style.background-image]="'url(' + (blogData?.image ? blogData?.image  :'assets/img/blog-detail-page-banner.png') + ')'">
    <div class="container">
        <!-- <h1 class="page-banner-title">Blog Details</h1> -->
    </div>
  </section>

  <section class="py-5">
    <div class="container">
        <div class="row">
            <div class="col"><h2 class="font-weight-bold mb-4">{{blogData?.title}}</h2></div>
            <div class="col-12 col-md-auto">
                <ol class="breadcrumb my-2 hide-on-phone">
                    <li class="breadcrumb-item"><a [routerLink]="['/home']">Home</a></li>
                    <li class="breadcrumb-item" *ngIf="!isNewsDetail"><a [routerLink]="['/blog']">Blog</a></li>
                    <li class="breadcrumb-item active" *ngIf="!isNewsDetail" aria-current="page">Blog Details</li>
                    <li class="breadcrumb-item" *ngIf="isNewsDetail"><a [routerLink]="['/investors']">Investor Relations</a></li>
                    <li class="breadcrumb-item active" *ngIf="isNewsDetail" aria-current="page">News Details</li>
                </ol>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-8 col-lg-7">
                <div class="blog-details text-76 fadeUpAnimation" [innerHTML]="blogData?.description">
                   </div>
            </div>
            <div class="col-xl-4 col-lg-5" *ngIf="blogPopular.length">
                <div class="card-blog-list">
                    <div class="card-blog-list-head">
                        Popular Posts
                    </div>
                    <div class="card-blog-list-body">
                        <ul class="blog-list">
                            <li *ngFor="let blog of blogPopular">
                                <a class="blog-list-a fadeUpAnimation" [routerLink]="isNewsDetail == true ? ['/investors'] : ['/blog'] " >
                                    <div class="blog-list-img">
                                        <img [src]="blog?.image">
                                    </div>
                                    <div class="blog-list-data">
                                        <h4>{{blog.title}}</h4>
                                        <div class="date">{{blog.createdAt | date :'fullDate'}}</div>
                                        <p class="text-76">{{blog.description.length < 100 ? blog.description : blog.description.slice(0,100)+'...'}}</p>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
  </section>
